export default {"src":"/_next/static/media/shield-icon.0f9280b6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};